import React from "react";
function SettingsComponent() {
  return (
    <div>
      <div>Student Settings</div>
    </div>
  );
}
export default SettingsComponent;
